import { Products } from "enums";

export const redemptionsFilterState = (fleetId, location) => {
  const { state } = location || {};
  const { searchKey = "" } = state || {};
  return {
    fleetId,
    startDate: null,
    endDate: null,
    dispensedTo: "all",
    redemptionStatus: "all",
    productCodes: [Products.Diesel, Products.Gas91, Products.Gas95, Products.Gas97],
    searchKey,
    redemptionStation: {
      value: null,
      label: "All",
    },
    page: 1,
    perPage: 10,
  };
};
